export default __webpack_public_path__ + "static/media/Pfeil_Hellblau_Nach_Oben_Boxen.d4523708.svg";